import { SET_MESSAGES } from '../../constants';

const initialState = {
  messagesList: [],
};

const messagesReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_MESSAGES:
      return { ...state, messagesList: action.messages };
    default:
      return state;
  }
};

export default messagesReducer;
